// @ts-nocheck

import { ColumnProps } from "antd/lib/table";

export const scrollTable = {
  x: true,
};

interface ColumnsTabs extends ColumnProps<IParticipant> {
  title: string;
}

export type IParticipant = {
  company_code: string;
  full_name_en: string;
  full_name_ru: string;
  job_name: string;
  organization_name: string;
  position_group_id: string;
  person_group_id: string;
}

export const columnsTable: ColumnsTabs[] = [
  {
    title: "FIO",
    dataIndex: "full_name_ru",
    key: "full_name_ru",
    sorter: (a, b) => (a.full_name_ru && b.full_name_ru) ? a.full_name_ru.localeCompare(b.full_name_ru) : 0,
  },
  {
    title: "concourseCompany",
    dataIndex: "company_code",
    key: "company_code",
    width: 200, // Устанавливаем начальную ширину
    fixed: "left", // Фиксируем слева
  },
  {
    title: "dismissalRequest.subdivision",
    dataIndex: "organization_name",
    key: "organization_name",
  },
  {
    title: "dismissalRequest.staffUnitPosition",
    dataIndex: "job_name",
    key: "job_name",
  },
];
